import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class PageTitleService {
  private state = new BehaviorSubject<{ icon: string; title: string }>({ icon: '', title: '' });
  readonly title$ = this.state.asObservable();

  set(icon: string, title: string): void {
    setTimeout(() => this.state.next({ icon, title }));
  }
}
